import { randBoolean, randEmail, randFullName, randUuid } from '@ngneat/falso';

import {
  ExternalInvitation,
  Scope,
} from '@/domain/external-invitation/entities/external-invitation.entity';
import { Status } from '@/domain/external-invitation/entities/external-invitation.entity';
import { ExternalInvitationGateway } from '@/domain/external-invitation/gateway/external-invitation.gateway';
import { getScopeUrlFromScope } from '@/domain/external-invitation/utils/scope-url/get-scope-url';
import { getCategoryFromScope } from '@/domain/external-invitation/utils/scopes/get-category';
import { Sector } from '@/domain/impact/impact.entity';
import { PositionGeocode } from '@/domain/position-geocode/position-geocode.entity';

import { FIRST_FAKE_PROJECT_FESTIVAL_ID } from './api-project-festival-fake.gateway';

export class ApiExternalInvitationFakeGateway implements ExternalInvitationGateway {
  // invitations: ExternalInvitation[] = [];
  invitations: ExternalInvitation[] = FAKE_INVITATIONS;

  async invite(
    name: string,
    email: string,
    limitDate: string,
    eventPosition: PositionGeocode | undefined,

    title: string,

    sector: Sector,
    scope: Scope,

    // eslint-disable-next-line unused-imports/no-unused-vars
    projectId: number,

    // eslint-disable-next-line unused-imports/no-unused-vars
    organisationId: number,
  ): Promise<void> {
    // 👨‍💻 dev - normal case
    const invitation = buildFakeInvitation({ code: randUuid(), scope, sector });
    invitation.name = name;
    invitation.email = email;
    invitation.expirationDate = limitDate;
    invitation.sector = sector;
    invitation.scope = scope;
    this.invitations = [...this.invitations, invitation];

    // 👨‍💻 dev - throw-error
    // throw 'error in api';
  }

  // eslint-disable-next-line unused-imports/no-unused-vars
  async getInvitations(projectId: number): Promise<ExternalInvitation[]> {
    // 👨‍💻 dev - normal case
    return this.invitations;

    // 👨‍💻 dev - throw-error
    // throw 'error in api';
  }

  async changeInvitationIsValidated(
    invitationId: number,
    isValidated: boolean,
  ): Promise<void> {
    await new Promise((r) => setTimeout(r, 500));
    const index = this.invitations.findIndex((x) => x.id === invitationId);
    const invitation = { ...this.invitations[index] };
    invitation.isValidated = isValidated;
    this.invitations = [...this.invitations];
    this.invitations[index] = invitation;
  }

  async changeInvitationStatus(
    invitationId: number,
    status: Status,
  ): Promise<void> {
    await new Promise((r) => setTimeout(r, 500));
    const index = this.invitations.findIndex((x) => x.id === invitationId);
    const invitation = { ...this.invitations[index] };
    invitation.status = status;
    this.invitations = [...this.invitations];
    this.invitations[index] = invitation;
  }
}

let idCounter = 0;

function buildFakeInvitation({
  code,
  sector = 'TEAM',
  scope = 'TEAM',
  status = 'IN_PROGRESS',
}: {
  code: string;
  sector?: Sector;
  scope?: Scope;
  status?: Status;
}): ExternalInvitation {
  return {
    id: idCounter++,
    projectId: FIRST_FAKE_PROJECT_FESTIVAL_ID,
    email: randEmail(),
    name: randFullName(),
    sector: sector,
    code: code,
    active: randBoolean(),
    scope: scope,
    scopeUrl: getScopeUrlFromScope(scope),
    expirationDate: '2024-01-19T23:00:00.000Z',
    eventPosition: {
      properties: {
        city: 'Lyon',
        name: 'Lyon',
        address: 'Lyon, Métropole de Lyon, Auvergne-Rhône-Alpes, France',
        countryCode: 'FR',
      },
      coordinates: [4.8320114, 45.7578137],
    },
    title: 'title',
    completion: 0.5,
    co2ImpactScore: '12',
    status: status,
    isValidated: false,
    category: getCategoryFromScope(scope),
    createdAt: new Date().toISOString(),
  };
}

const FAKE_INVITATIONS: ExternalInvitation[] = [
  // FESTIVAL
  buildFakeInvitation({
    code: '101',
    sector: 'TEAM',
    scope: 'TEAM',
  }),
  buildFakeInvitation({
    code: '101',
    sector: 'TEAM',
    status: 'SUBMITTED',
  }),
  buildFakeInvitation({ code: '102', sector: 'ARTISTS', scope: 'ARTISTS' }),
  buildFakeInvitation({
    code: '103',
    sector: 'PUBLIC',
    scope: 'PUBLIC_SUPPLIER',
  }),
  buildFakeInvitation({ code: '104', sector: 'SITE', scope: 'SITE' }),
  // public : unique invitation : unique link
  buildFakeInvitation({ code: '105', sector: 'PUBLIC', scope: 'PUBLIC' }),
  // FESTIVAL-CATEGORIES
  buildFakeInvitation({
    code: '106',
    sector: 'TEAM',
    scope: 'TEAM-MOBILITY',
  }),
  buildFakeInvitation({
    code: '107',
    sector: 'TEAM',
    scope: 'TEAM-CATERING',
  }),
  // VENUE-STRUCTURE
  buildFakeInvitation({
    code: '201',
    sector: 'SITE',
    scope: 'VENUE-STRUCTURE-SITE',
  }),
  buildFakeInvitation({
    code: '202',
    sector: 'TEAM',
    scope: 'VENUE-STRUCTURE-TEAM',
  }),
  // VENUE-STRUCTURE-CATEGORIES
  buildFakeInvitation({
    code: '2011',
    sector: 'SITE',
    scope: 'VENUE-STRUCTURE-SITE-SCENOGRAPHY',
  }),
  // VENUE-DATES
  buildFakeInvitation({
    code: '203',
    sector: 'ARTISTS',
    scope: 'VENUE-DATES-ARTISTS',
  }),
  // VENUE-DATES CATEGORIES
  buildFakeInvitation({
    code: '2031',
    sector: 'ARTISTS',
    scope: 'VENUE-DATES-ARTISTS-CARGO',
  }),
];
